<template>
  <div id="instances-slim-list">
    <div v-if="!minimum">
      <vs-table
        search
        pagination
        :data="groups"
        :max-items="itemsPerPage"
        noDataText="Sem dados disponíveis"
      >
        <template slot="thead">
          <vs-th style="width: 50px" v-if="checkbox"></vs-th>
          <vs-th sort-key="name">Nome</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <vs-checkbox v-model="selecteds" :vs-value="tr.id"/>
            </vs-td>
            <vs-td>
              <p>{{ tr.name }}</p>
            </vs-td>
          </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
    <div v-else class="category-filter-scroll">
      <VuePerfectScrollbar :key="$vs.rtl" :settings="settings">
        <div :key="indextr" v-for="(tr, indextr) in groups" class="flex mb-2">
          <vs-td>
            <vs-checkbox v-model="selecteds" :vs-value="tr.id" :title="tr.name">
              <div class="flex">
                <p class="align-self-center">{{ tr.name | truncate(20, true) }}</p>
              </div>
            </vs-checkbox>
          </vs-td>
        </div>
      </VuePerfectScrollbar>
    </div>
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import moduleCustomerGroup from "@/store/customerGroup/moduleCustomerGroup";

  export default {
    components: { VuePerfectScrollbar },
    props: {
      checkbox: {
        type: Boolean,
        required: false
      },
      search: {
        type: Boolean,
        required: false,
        default(){ return false }
      },
      selecteds: {
        required: false,
        default(){ return [] },
        validator: prop => typeof prop === 'object' || prop === null
      },
      minimum: {
        type: Boolean,
        required: false,
        default(){ return false },
      },
    },
    data() {
      return {
        itemsPerPage: 4,
        settings: {
          maxScrollbarLength: 60,
          wheelSpeed: .60
        }
      }
    },
    computed: {
      groups() {
        if (!moduleCustomerGroup.isRegistered) {
          this.$store.registerModule('customerGroup', moduleCustomerGroup)
          moduleCustomerGroup.isRegistered = true
        }

        return this.$store.state.customerGroup ? this.$store.state.customerGroup.groupsOfCustomerResume : []
      },
    },
    created() {
      if ( !this.groups.length ){
        this.$store.dispatch("customerGroup/fetchGroupsOfCustomerResume");
      }
    },
    watch: {
      selecteds: function() {
        this.$emit("selectedGroup", this.selecteds);
      }
    }
  }
</script>

<style lang="scss">
  .category-filter-scroll{
    width: 100%;
    height: 8rem;
    margin: auto;
    overflow-y: auto;
    position: relative;
    max-height: 100px !important;
  }
</style>
